"use strict";
/*
 * Created on 26. 1. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SalesDashboardComparatorRowDTO_1 = require("../model/SalesDashboardComparatorRowDTO");

var DashboardPromoType_1 = require("../sales-dashboard/DashboardPromoType");

var SalesDashboardComparatorRowDTOConverter_1 = require("./SalesDashboardComparatorRowDTOConverter");
/**
 * @author Tomas Leity
 */


var SalesDashboardComparatorRowDTOConverterImpl =
/*#__PURE__*/
function (_SalesDashboardCompar) {
  _inherits(SalesDashboardComparatorRowDTOConverterImpl, _SalesDashboardCompar);

  function SalesDashboardComparatorRowDTOConverterImpl() {
    _classCallCheck(this, SalesDashboardComparatorRowDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardComparatorRowDTOConverterImpl).apply(this, arguments));
  }

  _createClass(SalesDashboardComparatorRowDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO(SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.id.valueOf(conversions.documentToClassId(source)),
      /** Additional row information */
      SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.reportId.valueOf(source.reportId), SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.reportTime.valueOf(conversions.toDate(source.reportTime)), SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.categoryId.valueOf(conversions.toClassReferenceId(source.categoryId)),
      /** {@link SalesDashboardComparatorItem} params */
      SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.volumeDiff.valueOf(conversions.toBigNumber(source.volumeDiff)), SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.costValueDiff.valueOf(conversions.toBigNumber(source.costValueDiff)), SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.title.valueOf(source.title), SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.promoType.valueOf(conversions.asEnum(source.promoType, DashboardPromoType_1.DashboardPromoType)), SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.simulation.valueOf(source.simulation), SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.volumeSDR.valueOf(conversions.toBigNumber(source.volumeSDR)), SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.volumePPR.valueOf(conversions.toBigNumber(source.volumePPR)), SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.costValueSDR.valueOf(conversions.toBigNumber(source.costValueSDR)), SalesDashboardComparatorRowDTO_1.SalesDashboardComparatorRowDTO.schema.costValuePPR.valueOf(conversions.toBigNumber(source.costValuePPR)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        /** Additional row information */
        reportId: source.reportId,
        reportTime: conversions.fromDate(source.reportTime),
        categoryId: conversions.toDocumentReferenceId(source.categoryId),

        /** {@link SalesDashboardComparatorItem} params */
        volumeDiff: conversions.fromBigNumber(source.volumeDiff),
        costValueDiff: conversions.fromBigNumber(source.costValueDiff),
        title: source.title,
        promoType: source.promoType,
        simulation: source.simulation,
        volumeSDR: conversions.fromBigNumber(source.volumeSDR),
        volumePPR: conversions.fromBigNumber(source.volumePPR),
        costValueSDR: conversions.fromBigNumber(source.costValueSDR),
        costValuePPR: conversions.fromBigNumber(source.costValuePPR)
      });
      return result;
    }
  }]);

  return SalesDashboardComparatorRowDTOConverterImpl;
}(SalesDashboardComparatorRowDTOConverter_1.SalesDashboardComparatorRowDTOConverter);

exports.SalesDashboardComparatorRowDTOConverterImpl = SalesDashboardComparatorRowDTOConverterImpl;